import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import * as invites from '@webapp/sdk/invites';
import { Actions } from '../../actions';
import {
  CreateInvites,
  CreateInvitesSuccess,
  CreateInvitesError,
} from '../action-creators';
import { CREATE_INVITES } from '../actions';
import AppState from '../../state';
import { NoOp } from '@webapp/store/ui/action-creators';
import { newInviteList } from '../selectors';
import SimpleArtist from '@common/types/artist/simple-artist';
import { push } from 'connected-react-router';
import { Action } from 'redux';

export const sendInvitesEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateInvites>(CREATE_INVITES),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    mergeMap(async ([action, state]) => {
      try {
        const newInvites = newInviteList(state, action.inviteType, true);

        if (!newInvites.length) {
          return [new NoOp()];
        }

        const artist = state.artist.active;
        const invitesList = await invites.createInvites(
          artist as SimpleArtist,
          newInvites
        );

        let next: Action[] = [
          new CreateInvitesSuccess(action.inviteType, invitesList),
        ];

        if (action.redirect) {
          next = next.concat([push(action.redirect)]);
        }

        return next;
      } catch (err) {
        return [new CreateInvitesError(err.message)];
      }
    }),
    concatMap((actions) => actions)
  );
